import { createSelector } from '@ngrx/store';
import { RedeemedPromoCode } from '@products/models/smart-promotions';
import { getProductBookingState } from '@store/products/product.selectors';
import { isEmpty } from 'lodash';

/**
 * Select redeemed discount promo codes
 * @description Select redeemed discount promo codes
 * @returns Array of redeemed discount promo codes
 */
export const selectAllDiscountPromoCodes = createSelector(
  getProductBookingState,
  (productBookingState): RedeemedPromoCode[] => productBookingState.promoCodes
);

/**
 * Select redeemed valid discount promo codes
 * @description Select redeemed valid discount promo codes
 * @returns Array of redeemed valid discount promo codes
 */
export const selectRedeemedValidDiscountPromoCodes = createSelector(
  selectAllDiscountPromoCodes,
  (redeemedPromoCodes): RedeemedPromoCode[] =>
    redeemedPromoCodes.filter(({ isRedeemedAndApplied }) => isRedeemedAndApplied)
);

/**
 * Select is promo code discount applied
 * @description Select is promo code discount applied
 * @returns Boolean
 */
export const selectIsPromoCodeDiscountApplied = createSelector(
  selectRedeemedValidDiscountPromoCodes,
  (redeemedValidDiscountPromoCodes) => !isEmpty(redeemedValidDiscountPromoCodes)
);

/**
 * Select redeemed invalid promo codes
 * @description Select redeemed invalid promo codes
 * @returns Array of redeemed invalid promo codes
 */
export const selectRedeemedInvalidDiscountPromoCodes = createSelector(
  selectAllDiscountPromoCodes,
  (redeemedPromoCodes): RedeemedPromoCode[] =>
    redeemedPromoCodes.filter(({ isRedeemedAndApplied }) => !isRedeemedAndApplied)
);
